import { Instance, SnapshotIn, getSnapshot, types, flow } from 'mobx-state-tree';

import { EntitiesStore } from './Entities.store'

export const EntitiesUIStoreInferred = types
    .model('EntitiesUIStoreInferred', {
        _entity: types.optional(EntitiesStore, {}),
        entityId: types.maybeNull(types.string),
        errors: types.maybeNull(types.array(types.string)),
    })
    .views(self => ({
        get execution() { return self._entity; },
        get executionsUIData() { return getSnapshot(self) },
    }))
    .actions(self => {

        const loadEntity = flow(function* (payload){
            return yield self._entity.loadEntity(payload);
        })

        const setEntitiesUserId = (id: string | null | undefined) => {
            if (id) {
                self.entityId = id;
            }
        }

        const clearEntitiesUserId = () => self.entityId = null;

        return {
            loadEntity,
            setEntitiesUserId,
            clearEntitiesUserId,
        }
    });

type EntitiesUIStoreFactoryType = typeof EntitiesUIStoreInferred;
interface IEntitiesUIStoreFactory extends EntitiesUIStoreFactoryType { }
export const EntitiesUIStore: IEntitiesUIStoreFactory = EntitiesUIStoreInferred;
export interface IEntitiesUIStore extends Instance<IEntitiesUIStoreFactory> { }
export interface IEntitiesUIStoreSnapshotIn extends SnapshotIn<IEntitiesUIStore> { }
